<template>
  <div class="contact container">
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <card
          page="contact"
        >
          <form-component>
            <form
              novalidate="novalidate"
              @submit.prevent="doContact"
            >
              <input-text
                id="name"
                v-model="name"
                v-validate="'required'"
                name="name"
                data-vv-name="name"
                data-vv-as="name"
                label="Your Name"
                type="text"
                required
                :error="errors.first('name')"
              />

              <input-text
                id="email"
                v-model="email"
                v-validate="'required|email'"
                name="email"
                data-vv-name="email"
                data-vv-as="email"
                label="Email Address"
                type="email"
                required
                :error="errors.first('email')"
              />

              <input-text-area
                id="message"
                v-model="message"
                v-validate="'required'"
                name="message"
                data-vv-name="message"
                data-vv-as="message"
                label="Your Message"
                required
                :error="errors.first('message')"
              />

              <button
                type="submit"
                class="btn btn--primary btn--large"
              >
                <font-awesome-icon
                  v-if="saving"
                  :spin="true"
                  :icon="['fas', 'spinner']"
                  class="icon alt"
                />
                <span v-else>Contact Us</span>
              </button>
            </form>
          </form-component>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'Contact',
  components: {
    Card,
    FormComponent,
    InputText,
    InputTextArea,
  },
  data() {
    return {
      name: '',
      email: '',
      message: '',

      userClient: new UserClient(this.$http),
      saving: false,
    };
  },
  methods: {
    doContact() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          this.saving = true;
          this.userClient.submitContact(this.email, this.name, this.message).then((response) => {
            this.saving = false;
            this.email = '';
            this.name = '';
            this.message = '';
            this.$store.commit('setGlobalAlert', {
              msg: 'Thanks for contacting us! We will get back to you soon.',
            });
          }).catch((ex) => {
            this.saving = false;
            this.$store.commit('setGlobalAlert', {
              msg: 'Failed to submit contact info. Please try again!', error: true,
            });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  &__image {
    max-width: 80px;
    margin-bottom: $gutter;
  }

  &__card {
    text-align: center;
  }

  .btn {
    display: block;
    width: 100%;
  }
}
</style>
